const ConsentRefreshIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="315"
      height="235"
      viewBox="0 0 315 235"
      fill="none"
    >
      <path d="M315 206.518H0V206.675H315V206.518Z" fill="#EBEBEB" />
      <path
        d="M279.651 212.521H258.785V212.679H279.651V212.521Z"
        fill="#EBEBEB"
      />
      <path
        d="M114.238 214.654H82.8262V214.812H114.238V214.654Z"
        fill="#EBEBEB"
      />
      <path
        d="M258.155 218.381H239.551V218.539H258.155V218.381Z"
        fill="#EBEBEB"
      />
      <path
        d="M46.6588 217.322H33.0508V217.48H46.6588V217.322Z"
        fill="#EBEBEB"
      />
      <path
        d="M76.4387 217.322H52.2656V217.48H76.4387V217.322Z"
        fill="#EBEBEB"
      />
      <path
        d="M208.669 210.812H149.65V210.97H208.669V210.812Z"
        fill="#EBEBEB"
      />
      <path
        d="M149.317 178.39H27.6637C25.6792 178.39 24.0664 176.775 24.0664 174.788V3.60122C24.0664 1.61456 25.6792 0 27.6637 0H149.317C151.301 0 152.914 1.61456 152.914 3.60122V174.788C152.914 176.775 151.301 178.39 149.317 178.39ZM27.6637 0.157672C25.7674 0.157672 24.2239 1.70285 24.2239 3.60122V174.788C24.2239 176.687 25.7674 178.232 27.6637 178.232H149.317C151.213 178.232 152.757 176.687 152.757 174.788V3.60122C152.757 1.70285 151.213 0.157672 149.317 0.157672H27.6637Z"
        fill="#EBEBEB"
      />
      <path
        d="M285.586 178.39H163.933C161.949 178.39 160.336 176.775 160.336 174.788V3.60122C160.336 1.61456 161.949 0 163.933 0H285.586C287.571 0 289.184 1.61456 289.184 3.60122V174.788C289.184 176.775 287.571 178.39 285.586 178.39ZM163.933 0.157672C162.037 0.157672 160.493 1.70285 160.493 3.60122V174.788C160.493 176.687 162.037 178.232 163.933 178.232H285.586C287.483 178.232 289.026 176.687 289.026 174.788V3.60122C289.026 1.70285 287.483 0.157672 285.586 0.157672H163.933Z"
        fill="#EBEBEB"
      />
      <path
        d="M83.7588 202.949H91.9551V99.75H83.7588V202.949Z"
        fill="#F0F0F0"
      />
      <path
        d="M44.3763 206.506H89.793V202.942H44.3763V206.506Z"
        fill="#F0F0F0"
      />
      <path
        d="M83.759 99.7422H42.2168V202.941H83.759V99.7422Z"
        fill="#FAFAFA"
      />
      <path
        d="M79.3289 153.484H46.6445V171.913H79.3289V153.484Z"
        fill="#F0F0F0"
      />
      <path
        d="M79.3289 177.602H46.6445V196.03H79.3289V177.602Z"
        fill="#F0F0F0"
      />
      <path
        d="M58.4145 155.527H67.5495C68.0993 155.527 68.5449 155.081 68.5449 154.531V153.995C68.5449 153.444 68.0993 152.998 67.5495 152.998H58.4145C57.8648 152.998 57.4191 153.444 57.4191 153.995V154.531C57.4191 155.081 57.8648 155.527 58.4145 155.527Z"
        fill="#FAFAFA"
      />
      <path
        d="M58.4145 179.65H67.5495C68.0993 179.65 68.5449 179.204 68.5449 178.654V178.118C68.5449 177.567 68.0993 177.121 67.5495 177.121H58.4145C57.8648 177.121 57.4191 177.567 57.4191 178.118V178.654C57.4191 179.204 57.8648 179.65 58.4145 179.65Z"
        fill="#FAFAFA"
      />
      <path
        d="M79.3289 105.432H46.6445V123.86H79.3289V105.432Z"
        fill="#F0F0F0"
      />
      <path
        d="M79.3289 129.367H46.6445V147.796H79.3289V129.367Z"
        fill="#F0F0F0"
      />
      <path
        d="M58.4145 107.482H67.5495C68.0993 107.482 68.5449 107.036 68.5449 106.486V105.95C68.5449 105.4 68.0993 104.953 67.5495 104.953H58.4145C57.8648 104.953 57.4191 105.4 57.4191 105.95V106.486C57.4191 107.036 57.8648 107.482 58.4145 107.482Z"
        fill="#FAFAFA"
      />
      <path
        d="M67.5495 131.41H58.4145C57.8664 131.41 57.4191 130.962 57.4191 130.414V129.878C57.4191 129.329 57.8664 128.881 58.4145 128.881H67.5495C68.0976 128.881 68.5449 129.329 68.5449 129.878V130.414C68.5449 130.962 68.0976 131.41 67.5495 131.41Z"
        fill="#FAFAFA"
      />
      <path
        d="M129.219 202.949H142.783V99.75H129.219V202.949Z"
        fill="#F0F0F0"
      />
      <path
        d="M89.8385 206.506H140.264V202.942H89.8385V206.506Z"
        fill="#F0F0F0"
      />
      <path
        d="M129.22 99.7422H87.6777V202.941H129.22V99.7422Z"
        fill="#FAFAFA"
      />
      <path
        d="M124.79 153.484H92.1055V171.913H124.79V153.484Z"
        fill="#F0F0F0"
      />
      <path d="M124.79 177.602H92.1055V196.03H124.79V177.602Z" fill="#F0F0F0" />
      <path
        d="M103.881 155.527H113.016C113.566 155.527 114.012 155.081 114.012 154.531V153.995C114.012 153.444 113.566 152.998 113.016 152.998H103.881C103.332 152.998 102.886 153.444 102.886 153.995V154.531C102.886 155.081 103.332 155.527 103.881 155.527Z"
        fill="#FAFAFA"
      />
      <path
        d="M103.881 179.65H113.016C113.566 179.65 114.012 179.204 114.012 178.654V178.118C114.012 177.567 113.566 177.121 113.016 177.121H103.881C103.332 177.121 102.886 177.567 102.886 178.118V178.654C102.886 179.204 103.332 179.65 103.881 179.65Z"
        fill="#FAFAFA"
      />
      <path d="M124.79 105.432H92.1055V123.86H124.79V105.432Z" fill="#F0F0F0" />
      <path
        d="M124.79 129.367H92.1055V147.796H124.79V129.367Z"
        fill="#F0F0F0"
      />
      <path
        d="M103.881 107.482H113.016C113.566 107.482 114.012 107.036 114.012 106.486V105.95C114.012 105.4 113.566 104.953 113.016 104.953H103.881C103.332 104.953 102.886 105.4 102.886 105.95V106.486C102.886 107.036 103.332 107.482 103.881 107.482Z"
        fill="#FAFAFA"
      />
      <path
        d="M113.016 131.41H103.881C103.333 131.41 102.886 130.962 102.886 130.414V129.878C102.886 129.329 103.333 128.881 103.881 128.881H113.016C113.564 128.881 114.012 129.329 114.012 129.878V130.414C114.012 130.962 113.564 131.41 113.016 131.41Z"
        fill="#FAFAFA"
      />
      <path d="M40.962 66.7383H147.539V22.174H40.962V66.7383Z" fill="#E6E6E6" />
      <path
        d="M36.3771 66.7383H146.318V22.174H36.3771V66.7383Z"
        fill="#F0F0F0"
      />
      <path
        d="M140.51 60.9247V27.9902H42.1857V60.9247H140.51Z"
        fill="#FAFAFA"
      />
      <path
        d="M92.3524 60.9247L82.5874 27.9902H69.4141L79.1791 60.9247H92.3524Z"
        fill="white"
      />
      <path
        d="M128.432 60.9247L118.667 27.9902H105.494L115.259 60.9247H128.432Z"
        fill="white"
      />
      <path
        d="M76.6903 60.9247L66.9253 27.9902H53.752L63.517 60.9247H76.6903Z"
        fill="white"
      />
      <path
        d="M241.102 10.0469H182.373V102.613H241.102V10.0469Z"
        fill="#EBEBEB"
      />
      <path
        d="M236.943 98.4502V14.2031H186.531V98.4502H236.943Z"
        fill="#FAFAFA"
      />
      <path
        d="M210.175 98.4502H208.48L213.306 14.1211H214.995L210.175 98.4502Z"
        fill="#E0E0E0"
      />
      <path
        d="M213.33 33.0299V35.4581L236.942 29.2269V28.3691L213.33 33.0299Z"
        fill="#E0E0E0"
      />
      <path
        d="M211.736 60.6653V63.0935L236.943 53.1097V52.252L211.736 60.6653Z"
        fill="#E0E0E0"
      />
      <path
        d="M209.557 89.1915V92.5531L236.943 77.3851V76.5273L209.557 89.1915Z"
        fill="#E0E0E0"
      />
      <path
        d="M212.366 45.4856V47.9138L187.16 37.93V37.0723L212.366 45.4856Z"
        fill="#E0E0E0"
      />
      <path
        d="M210.325 74.8496V78.2049L187.16 65.8245V64.9668L210.325 74.8496Z"
        fill="#E0E0E0"
      />
      <path
        d="M187.154 98.4561V14.209H186.531V98.4561H187.154Z"
        fill="#E0E0E0"
      />
      <path
        d="M241.102 102.613L243.035 102.613V10.0475L241.102 10.0469V102.613Z"
        fill="#E0E0E0"
      />
      <path
        d="M264.19 95.8193C264.19 91.9847 265.677 86.2266 265.677 86.2266H253.896C253.896 86.2266 255.383 91.9847 255.383 95.8193C255.383 99.6539 250.721 106.547 250.721 112.041C250.721 117.534 255.421 124.383 255.421 124.383H264.14C264.14 124.383 268.84 117.54 268.84 112.041C268.84 106.541 264.177 99.6539 264.177 95.8193H264.19Z"
        fill="#E0E0E0"
      />
      <path
        d="M271.745 101.201C271.745 98.0851 272.306 93.418 272.306 93.418H267.845C267.845 93.418 268.412 98.0914 268.412 101.201C268.412 104.31 266.648 109.904 266.648 114.363C266.648 118.822 268.431 124.378 268.431 124.378H271.733C271.733 124.378 273.515 118.822 273.515 114.363C273.515 109.904 271.751 104.316 271.751 101.201H271.745Z"
        fill="#F0F0F0"
      />
      <path
        d="M162.766 206.518H169.463V124.383H162.766V206.518Z"
        fill="#E6E6E6"
      />
      <path
        d="M160.972 206.518H164.916V124.383H160.972V206.518Z"
        fill="#F0F0F0"
      />
      <path
        d="M254.855 124.377H159.75V128.584H254.855V124.377Z"
        fill="#F0F0F0"
      />
      <path
        d="M287.141 206.518H293.838V124.383H287.141V206.518Z"
        fill="#E6E6E6"
      />
      <path
        d="M285.88 206.518H289.824V124.383H285.88V206.518Z"
        fill="#F0F0F0"
      />
      <path
        d="M295.036 124.377H257.721V128.584H295.036V124.377Z"
        fill="#E6E6E6"
      />
      <path
        d="M255.42 206.518H262.117V124.383L255.421 124.383L255.42 206.518Z"
        fill="#E6E6E6"
      />
      <path
        d="M253.632 206.518H257.576V124.383H253.632V206.518Z"
        fill="#F0F0F0"
      />
      <path
        d="M162.137 124.377L207.301 151.534L252.466 124.377H162.137Z"
        fill="#FAFAFA"
      />
      <path
        d="M166.352 124.377L207.302 148.999L248.252 124.377H166.352Z"
        fill="#EBEBEB"
      />
      <path
        d="M260.939 124.377L277.175 148.999L293.416 124.377H260.939Z"
        fill="#FAFAFA"
      />
      <path
        d="M262.873 124.377L277.596 146.464L292.319 124.377H262.873Z"
        fill="#EBEBEB"
      />
      <path
        d="M157.5 234.999C224.962 234.999 279.651 231.803 279.651 227.86C279.651 223.917 224.962 220.721 157.5 220.721C90.0383 220.721 35.3496 223.917 35.3496 227.86C35.3496 231.803 90.0383 234.999 157.5 234.999Z"
        fill="#F5F5F5"
      />
      <path
        d="M127.116 222.045L122.057 220.38L124.558 208.195L129.623 209.86L127.116 222.045Z"
        fill="#FFB573"
      />
      <path
        d="M171.177 222.109H165.841L164.518 209.748H169.847L171.177 222.109Z"
        fill="#FFB573"
      />
      <path
        d="M165.406 221.49H171.908C172.128 221.49 172.317 221.642 172.361 221.856L173.413 226.599C173.52 227.091 173.136 227.557 172.632 227.545C170.54 227.507 169.016 227.387 166.382 227.387C164.763 227.387 159.874 227.557 157.638 227.557C155.402 227.557 155.105 225.344 156.025 225.142C160.133 224.24 163.226 223.004 164.543 221.818C164.782 221.604 165.091 221.49 165.406 221.49Z"
        fill="#221C3A"
      />
      <path
        d="M122.144 219.58L127.758 221.132C127.965 221.188 128.11 221.384 128.098 221.605L127.852 226.461C127.827 226.966 127.342 227.312 126.863 227.174C124.847 226.581 121.955 225.654 119.41 224.954C116.436 224.134 115.882 223.85 112.392 222.885C110.281 222.305 110.281 220.009 111.22 220.053C115.485 220.28 116.733 220.829 120.796 219.643C121.237 219.517 121.703 219.46 122.144 219.586V219.58Z"
        fill="#221C3A"
      />
      <path
        d="M148.402 59.9587C148.062 60.4065 147.797 60.7281 147.495 61.1002C147.205 61.4597 146.903 61.8066 146.6 62.1472C145.995 62.8346 145.378 63.5032 144.742 64.1591C143.482 65.4835 142.134 66.726 140.71 67.918C137.85 70.2704 134.681 72.4463 130.787 73.8212C129.817 74.1618 128.79 74.433 127.719 74.6095C127.448 74.6537 127.184 74.6978 126.913 74.7294L126.081 74.8051C125.854 74.8366 125.42 74.8366 125.035 74.8303C124.683 74.8051 124.317 74.7735 124.008 74.7168C122.736 74.5023 121.734 74.1113 120.795 73.7077C119.863 73.304 119.019 72.8499 118.212 72.3643C116.6 71.4057 115.132 70.3524 113.733 69.2298C112.328 68.1072 111.03 66.9404 109.758 65.6349L112.177 62.4373C115.138 63.9131 118.162 65.4583 121.06 66.5809C121.785 66.8521 122.496 67.0981 123.164 67.2873C123.826 67.4765 124.475 67.5774 124.897 67.5837C125.004 67.5837 125.073 67.5711 125.142 67.5711C125.187 67.5522 125.18 67.5585 125.376 67.5206L125.817 67.4449L126.27 67.3377C126.566 67.281 126.881 67.1548 127.184 67.0665C127.492 66.9404 127.801 66.8458 128.116 66.7007C129.37 66.1836 130.63 65.4583 131.852 64.6005C133.087 63.768 134.29 62.7968 135.462 61.7625C136.64 60.7344 137.768 59.6244 138.876 58.4892C139.431 57.9153 139.973 57.335 140.496 56.7422L141.277 55.8529L141.995 55.0078L148.396 59.9524L148.402 59.9587Z"
        fill="#FFB573"
      />
      <path
        d="M151.332 57.317C151.729 62.4066 140.282 72.7877 140.282 72.7877L130.164 64.0023C130.164 64.0023 134.423 59.4866 139.211 54.9456C142.499 51.8174 150.904 51.8174 151.332 57.317Z"
        fill="white"
      />
      <path
        d="M151.332 57.317C151.729 62.4066 140.282 72.7877 140.282 72.7877L130.164 64.0023C130.164 64.0023 134.423 59.4866 139.211 54.9456C142.499 51.8174 150.904 51.8174 151.332 57.317Z"
        fill="#FFF8F8"
      />
      <path
        d="M146.173 59.9342C141.466 60.363 138.461 64.1471 137.151 68.3286C137.006 68.7953 136.88 69.2746 136.779 69.7476L140.282 72.7877C140.282 72.7877 145.486 68.0637 148.756 63.4282C148.919 61.2334 148.296 59.7449 146.173 59.9342Z"
        fill="black"
      />
      <path
        d="M113.419 64.703L111.687 60.3008L105.777 62.1172C105.777 62.1172 107.787 64.293 110.011 65.8067L113.419 64.703Z"
        fill="#FFB573"
      />
      <path
        d="M108.706 56.8555L103.83 58.8169L105.777 62.1154L111.686 60.299L108.706 56.8555Z"
        fill="#FFC0A1"
      />
      <path
        d="M124.556 208.203L123.051 215.513L128.192 216.825L129.622 209.868L124.556 208.203Z"
        fill="black"
      />
      <path
        d="M169.847 209.754H164.518L165.204 216.124H170.534L169.847 209.754Z"
        fill="black"
      />
      <path
        d="M172.998 54.8573C171.353 60.7542 170.301 66.7583 169.608 72.4156C169.104 76.5529 168.802 80.4947 168.613 84.077C168.172 92.4651 168.354 98.8603 168.102 101.03C163.932 100.74 148.226 99.6486 139.658 99.0495C135.783 68.6945 143.18 53.0472 143.18 53.0472C143.18 53.0472 146.33 52.4165 149.99 52.2021C150.469 52.1706 150.96 52.1516 151.458 52.1453C154.677 52.076 159.931 52.5616 163.554 52.9905C164.316 53.0787 165.085 53.1923 165.835 53.3121C169.646 53.9302 172.998 54.8636 172.998 54.8636V54.8573Z"
        fill="white"
      />
      <path
        d="M172.998 54.8573C171.353 60.7542 170.301 66.7583 169.608 72.4156C169.104 76.5529 168.802 80.4947 168.613 84.077C168.172 92.4651 168.354 98.8603 168.102 101.03C163.932 100.74 148.226 99.6486 139.658 99.0495C135.783 68.6945 143.18 53.0472 143.18 53.0472C143.18 53.0472 146.33 52.4165 149.99 52.2021C150.469 52.1706 150.96 52.1516 151.458 52.1453C154.677 52.076 159.931 52.5616 163.554 52.9905C164.316 53.0787 165.085 53.1923 165.835 53.3121C169.646 53.9302 172.998 54.8636 172.998 54.8636V54.8573Z"
        fill="#FFF8F8"
      />
      <path
        d="M165.809 62.5391C165.79 67.3134 167.107 71.3434 169.33 74.8753C169.412 74.0617 169.507 73.2418 169.608 72.4156C169.986 69.3063 170.477 66.0898 171.126 62.8418L165.815 62.5391H165.809Z"
        fill="black"
      />
      <path
        d="M163.308 39.2719C162.274 43.1128 161.014 50.1954 163.553 52.9831C161.411 54.9003 158.337 56.4455 153.971 56.0419C150.626 55.7328 150.626 53.3804 151.457 52.1379C155.867 51.4063 155.981 48.1709 155.439 45.0932L163.301 39.2656L163.308 39.2719Z"
        fill="#FFC0A1"
      />
      <path
        d="M160.101 41.6504L155.445 45.0939C155.578 45.8255 155.666 46.5571 155.666 47.2698C157.342 47.1437 159.742 45.485 160.038 43.7569C160.189 42.8991 160.208 42.0603 160.095 41.6504H160.101Z"
        fill="black"
      />
      <path
        d="M154.855 33.5276C153.595 35.3124 150.294 32.0265 150.413 29.0749C155.208 28.4379 152.921 24.9376 157.28 25.8332C160.897 26.5774 156.235 31.5724 154.855 33.5276Z"
        fill="#263238"
      />
      <path
        d="M166.786 34.6814C165.179 39.7269 164.499 42.7668 161.254 44.7471C156.365 47.724 150.639 43.7822 150.702 38.3583C150.758 33.4768 153.373 26.041 158.898 25.2652C164.341 24.5021 168.392 29.6359 166.786 34.6877V34.6814Z"
        fill="#FFC0A1"
      />
      <path
        d="M160.396 40.192C162.19 39.5806 164.248 35.6957 164.471 35.9743C164.652 36.1862 164.853 36.2885 165.064 36.3361C164.254 37.5689 163.154 38.645 163.276 40.3047C163.316 40.9188 163.701 41.3364 164.159 41.4739C163.375 42.8039 162.495 44.0552 161.416 44.8394C159.699 46.1073 157.747 46.5006 155.745 47.1679C153.65 47.86 151.435 47.1782 151.203 44.2723C151.102 42.9713 150.865 41.3426 150.879 39.5423C153.21 39.1773 155.624 41.9928 160.396 40.192Z"
        fill="#AC8979"
      />
      <path
        d="M163.761 39.2724C163.761 39.2724 163.32 37.0146 163.554 35.482C163.78 34.0314 164.48 32.6187 164.48 32.6187C164.48 32.6187 161.462 30.8338 161.393 28.6832C161.393 28.6832 155.994 30.2788 153.121 27.8507C150.242 25.4225 152.812 22.6097 151.338 21.5375C154.866 21.1906 155.937 23.3413 158.167 22.8746C160.315 22.4268 158.425 20.8375 158.721 19.1094C165.444 24.9054 168.367 22.1871 171.63 25.5045C173.715 27.6236 171.523 31.6033 171.523 31.6033C171.523 31.6033 174.849 37.2668 163.761 39.2724Z"
        fill="#263238"
      />
      <path
        d="M170.453 31.4708C170.453 31.4708 173.754 32.1519 173.843 28.6895C175.544 32.215 173.414 32.7385 170.453 31.4708Z"
        fill="#263238"
      />
      <path
        d="M167.681 40.2574C166.66 41.2538 165.274 41.6827 164.102 41.6449C162.338 41.5944 161.979 39.8852 162.912 38.4977C163.75 37.249 165.671 35.7669 167.227 36.4922C168.764 37.2111 168.853 39.1158 167.681 40.2574Z"
        fill="#FFC0A1"
      />
      <path
        d="M120.33 218.848L129.436 221.371C129.436 221.371 140.844 185.171 143.647 165.289C144.392 160.018 145.539 152.603 147.286 144.703C149.495 134.746 152.272 123.985 154.54 115.554C156.934 106.678 158.76 100.392 158.76 100.392L139.189 99.0176C139.189 99.0176 131.177 143.157 129.305 160.197C127.359 177.915 120.33 218.848 120.33 218.848Z"
        fill="#221C3A"
      />
      <path
        d="M147.395 142.441C149.505 132.981 152.158 122.758 154.325 114.748L152.384 110.566C147.748 116.085 146.5 133.164 147.395 142.441Z"
        fill="black"
      />
      <path
        d="M149.939 99.6484C149.939 99.6484 152.06 147.702 154.432 163.972C157.023 181.793 163.609 220.74 163.609 220.74H173.879C173.879 220.74 170.48 179.757 168.983 162.26C167.273 142.336 169.254 100.995 169.254 100.995L149.953 99.6484H149.939Z"
        fill="#221C3A"
      />
      <path
        d="M140.703 80.683C140.778 80.5356 140.878 80.4128 141.028 80.3146C146.077 76.3108 148.776 70.3911 151.701 56.7832L153.75 57.7166C153.75 57.7166 151.551 77.6126 144.902 85.3745C143.628 86.8729 139.404 86.3816 138.204 86.2097C138.029 86.1851 137.954 86.0132 138.029 85.8658L140.703 80.683Z"
        fill="#FFAF80"
      />
      <path
        d="M150.6 53.7294C150.719 54.7177 151.195 55.7059 151.908 56.4824L152.431 55.1648C151.884 54.5294 151.432 53.7765 151.123 53C150.981 53.1647 150.6 53.6824 150.6 53.7294ZM156.71 56.8589C155.949 57.353 154.975 57.5177 154 57.353L154.594 56.1059C155.379 56.2236 156.163 56.1765 156.9 55.9648C156.877 56.1765 156.734 56.8354 156.71 56.8589Z"
        fill="#FFAF80"
      />
      <path
        d="M154.968 56.3262C155.218 57.154 154.308 59.3614 153.329 59.3062C151.782 59.2234 150.644 57.6507 151.554 54.3396C151.645 54.0084 152.351 54.8086 153.193 55.3329C153.966 55.802 154.854 55.9123 154.968 56.3262Z"
        fill="#FFAF80"
      />
      <path
        d="M163.643 222.424C163.24 222.424 162.856 222.354 162.616 222.152C162.427 221.995 162.339 221.768 162.358 221.484C162.371 221.276 162.484 221.175 162.572 221.124C163.164 220.822 164.884 221.881 165.073 222.001C165.117 222.026 165.136 222.077 165.13 222.127C165.124 222.178 165.086 222.216 165.035 222.228C164.664 222.316 164.135 222.417 163.643 222.417V222.424ZM162.849 221.32C162.786 221.32 162.73 221.333 162.686 221.352C162.654 221.37 162.61 221.402 162.604 221.503C162.591 221.705 162.648 221.856 162.774 221.963C163.064 222.209 163.763 222.241 164.664 222.058C164.065 221.711 163.253 221.32 162.843 221.32H162.849Z"
        fill="#407BFF"
      />
      <path
        d="M165.009 222.235C165.009 222.235 164.965 222.235 164.946 222.223C164.391 221.92 163.327 220.753 163.44 220.16C163.459 220.053 163.541 219.864 163.843 219.826C164.039 219.801 164.221 219.858 164.379 219.99C164.996 220.495 165.128 222.04 165.128 222.103C165.128 222.147 165.11 222.191 165.072 222.216C165.053 222.229 165.028 222.235 165.002 222.235H165.009ZM163.931 220.072C163.931 220.072 163.894 220.072 163.875 220.072C163.711 220.091 163.698 220.167 163.692 220.198C163.623 220.551 164.303 221.434 164.851 221.851C164.788 221.403 164.618 220.501 164.221 220.179C164.133 220.104 164.032 220.066 163.931 220.066V220.072Z"
        fill="#407BFF"
      />
      <path
        d="M121.446 220.148C121.446 220.148 121.433 220.148 121.42 220.148C120.545 220.085 119.02 219.883 118.592 219.227C118.466 219.031 118.441 218.811 118.529 218.571C118.579 218.432 118.68 218.338 118.819 218.3C119.53 218.129 121.313 219.744 121.515 219.927C121.553 219.965 121.565 220.021 121.546 220.072C121.528 220.116 121.49 220.141 121.446 220.148ZM118.913 218.539C118.913 218.539 118.888 218.539 118.875 218.539C118.819 218.552 118.787 218.583 118.762 218.647C118.705 218.811 118.718 218.949 118.8 219.082C119.039 219.448 119.871 219.731 121.055 219.857C120.337 219.239 119.323 218.489 118.907 218.533L118.913 218.539Z"
        fill="#407BFF"
      />
      <path
        d="M121.35 220.11C121.35 220.11 121.338 220.098 121.338 220.091C120.859 219.36 120.084 218.023 120.349 217.285C120.424 217.064 120.588 216.913 120.827 216.837C120.972 216.793 121.105 216.812 121.218 216.906C121.785 217.373 121.596 219.77 121.571 220.041C121.571 220.091 121.527 220.142 121.476 220.155C121.432 220.167 121.388 220.155 121.357 220.117L121.35 220.11ZM121.086 217.121C121.086 217.121 121.067 217.102 121.061 217.096C121.016 217.058 120.966 217.052 120.903 217.07C120.739 217.121 120.638 217.216 120.582 217.367C120.437 217.783 120.72 218.616 121.344 219.631C121.401 218.685 121.369 217.424 121.086 217.121Z"
        fill="#407BFF"
      />
      <path
        d="M173.785 57.9277C175.014 59.6621 176.059 61.3397 177.124 63.0868C178.189 64.8148 179.172 66.5997 180.129 68.4097C182.007 72.0488 183.733 75.8014 184.942 79.9954C185.087 80.5252 185.226 81.055 185.352 81.6037C185.415 81.8749 185.478 82.1524 185.528 82.4299L185.61 82.8462L185.654 83.0606L185.705 83.4012C185.913 85.1797 185.629 86.4852 185.32 87.6709C184.665 90.0234 183.714 91.9343 182.693 93.7822C181.666 95.6175 180.545 97.3393 179.348 98.9917C178.151 100.65 176.91 102.221 175.524 103.766L172.248 101.464C173.955 98.0394 175.694 94.5265 177.03 91.0829C177.364 90.2252 177.666 89.3674 177.918 88.5286C178.183 87.6961 178.39 86.8762 178.498 86.132C178.611 85.4067 178.598 84.7256 178.516 84.5427C178.516 84.5364 178.51 84.5238 178.504 84.5175L178.466 84.3724L178.384 84.0697C178.334 83.8679 178.277 83.666 178.208 83.4642C178.088 83.0606 177.943 82.6443 177.798 82.2344C176.608 78.9107 174.888 75.5365 173.048 72.2443C172.128 70.5856 171.145 68.9584 170.169 67.3186C169.192 65.6978 168.128 64.0517 167.139 62.5254L173.785 57.9277Z"
        fill="#FFC0A1"
      />
      <path
        d="M172.998 54.8573C177.993 55.8664 182.379 68.1021 182.379 68.1021L171.953 76.6037C171.953 76.6037 168.538 70.3852 165.804 64.3873C162.824 57.8534 166.95 53.6405 173.005 54.8577L172.998 54.8573Z"
        fill="white"
      />
      <path
        d="M172.998 54.8573C177.993 55.8664 182.379 68.1021 182.379 68.1021L171.953 76.6037C171.953 76.6037 168.538 70.3852 165.804 64.3873C162.824 57.8534 166.95 53.6405 173.005 54.8577L172.998 54.8573Z"
        fill="#FFF8F8"
      />
      <path
        d="M103.251 72.1835L100.732 81.2754L101.333 81.4422L103.852 72.3503L103.251 72.1835Z"
        fill="#407BFF"
      />
      <path
        d="M99.81 84.6265L98.7207 88.5586L99.3217 88.7254L100.411 84.7933L99.81 84.6265Z"
        fill="#407BFF"
      />
      <path
        d="M170.835 67.95L118.463 53.4297C114.482 52.3262 110.362 54.6618 109.26 58.6463L94.7555 111.076C93.6532 115.06 95.9862 119.185 99.9664 120.289L152.339 134.809C156.319 135.912 160.439 133.577 161.542 129.592L176.046 77.1628C177.148 73.1782 174.815 69.0535 170.835 67.95Z"
        fill="#154BB4"
      />
      <path
        d="M139.576 82.1542C139.299 82.1542 139.021 82.1163 138.744 82.0406C137.087 81.5802 136.111 79.8648 136.571 78.1998L139.084 69.1179C139.544 67.4592 141.264 66.4816 142.921 66.942C144.578 67.4024 145.555 69.1179 145.095 70.7829L142.581 79.8648C142.197 81.246 140.943 82.1542 139.582 82.1542H139.576Z"
        fill="white"
      />
      <path
        d="M128.722 120.165C128.558 120.165 128.388 120.14 128.224 120.096C127.229 119.818 126.643 118.79 126.92 117.794L129.434 108.712C129.711 107.716 130.738 107.135 131.734 107.407C132.729 107.684 133.315 108.712 133.038 109.709L130.524 118.79C130.297 119.617 129.541 120.165 128.722 120.165Z"
        fill="white"
      />
      <path
        d="M149.015 87.3435C148.687 87.3435 148.372 87.1732 148.202 86.8705C147.95 86.4227 148.108 85.8487 148.555 85.5965L156.751 80.9483C157.198 80.696 157.772 80.8537 158.024 81.3015C158.276 81.7493 158.118 82.3232 157.671 82.5755L149.475 87.2236C149.33 87.3056 149.172 87.3435 149.015 87.3435Z"
        fill="white"
      />
      <path
        d="M113.608 108.661C112.845 108.661 112.108 108.264 111.705 107.551C111.113 106.504 111.478 105.167 112.53 104.574L120.727 99.9261C121.773 99.3333 123.108 99.6991 123.7 100.752C124.293 101.799 123.927 103.136 122.875 103.729L114.679 108.377C114.339 108.573 113.973 108.661 113.608 108.661Z"
        fill="white"
      />
      <path
        d="M159.547 102.063C159.44 102.063 159.326 102.051 159.213 102.019L150.141 99.5026C149.479 99.3197 149.089 98.6323 149.272 97.9701C149.454 97.3078 150.141 96.9168 150.802 97.0997L159.874 99.6161C160.536 99.799 160.927 100.486 160.744 101.149C160.593 101.704 160.089 102.063 159.541 102.063H159.547Z"
        fill="white"
      />
      <path
        d="M120.337 92.439C120.116 92.439 119.896 92.4075 119.669 92.3507L110.597 89.8343C109.267 89.4685 108.493 88.0936 108.858 86.7628C109.223 85.4321 110.597 84.6563 111.926 85.0221L120.998 87.5386C122.327 87.9044 123.102 89.2793 122.737 90.61C122.428 91.7137 121.426 92.439 120.337 92.439Z"
        fill="white"
      />
      <path
        d="M147.748 117.504C147.206 117.504 146.677 117.22 146.393 116.716L141.75 108.51C141.328 107.76 141.592 106.807 142.336 106.385C143.086 105.962 144.037 106.227 144.459 106.971L149.102 115.177C149.524 115.927 149.26 116.88 148.516 117.302C148.27 117.441 148.012 117.504 147.748 117.504Z"
        fill="white"
      />
      <path
        d="M127.702 83.3079C126.725 83.3079 125.774 82.7971 125.257 81.8826L120.614 73.6773C119.852 72.3277 120.325 70.6122 121.673 69.8491C123.021 69.0859 124.734 69.559 125.497 70.9086L130.14 79.1139C130.902 80.4635 130.43 82.179 129.081 82.9421C128.647 83.1881 128.168 83.3079 127.702 83.3079Z"
        fill="white"
      />
      <path
        d="M174.138 100.24L168.732 100.045L171.353 106.339C171.353 106.339 175.996 105.481 175.814 102.965L174.144 100.234L174.138 100.24Z"
        fill="#FFB573"
      />
      <path
        d="M165.111 102.643L166.415 107.455L171.348 106.339L168.734 100.045L165.111 102.643Z"
        fill="#FFB573"
      />
    </svg>
  );
};
export default ConsentRefreshIcon;
